var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_240_13474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.1344,
    height: 23.1344,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_240_13474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11657 19.7604C4.62963 19.7604 4.21746 19.5917 3.88009 19.2543C3.54271 18.917 3.37402 18.5048 3.37402 18.0178L3.37402 5.11608C3.37402 4.62914 3.54271 4.21698 3.88009 3.8796C4.21746 3.54222 4.62963 3.37354 5.11657 3.37354L11.5766 3.37354V4.81943L5.11657 4.81943C5.04235 4.81943 4.97439 4.85036 4.9127 4.91221C4.85085 4.9739 4.81992 5.04186 4.81992 5.11608L4.81992 18.0178C4.81992 18.0921 4.85085 18.16 4.9127 18.2217C4.97439 18.2836 5.04235 18.3145 5.11657 18.3145H11.5766V19.7604H5.11657ZM15.6456 15.6822L14.6446 14.6366L16.9915 12.2899L8.76843 12.2899V10.844L16.9915 10.844L14.6446 8.49732L15.6456 7.45169L19.7609 11.567L15.6456 15.6822Z",
    fill: "#DC2626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c1d0c89935e22c0de934e691b97b424d.svg";
export { ForwardRef as ReactComponent };